export { default as Button } from './button/Button';
export { default as Input } from './input/Input';
export { default as InputSelect } from './inputSelect/InputSelect';
export { default as CheckCard } from './checkCard/checkCard';
export { default as InputCheck } from './inputCheck/inputCheck';
export { default as MultipleSelection } from './MultipleSelection/MultipleSelection';

export function GetGuid(): string {
    var result: string;
    var i: string;
    var j: number;

    result = '';
    for (j = 0; j < 32; j++) {
        if (j == 8 || j == 12 || j == 16 || j == 20) result = result + '-';
        i = Math.floor(Math.random() * 16)
            .toString(16)
            .toUpperCase();
        result = result + i;
    }
    return result;
}

export const CssLabel = {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '16px',
    color: '#404040',
    marginLeft: '5px',
    marginTop: '5px'
};
export const CssGroup = {
    marginTop: '10px'
};
